module.exports = __webpack_public_path__ + "static/home-offer-2-35fc2d24013f9980f3814679e474bc3a.webp";